'use client';

import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect } from 'react';
import { updateFeatureToggles } from '@next-app/lib/store';
import Script from 'next/script';

const FeatureToggles = () => {
  const dispatch = useDispatch();
  const { sessionInfo } = useSelector((state: any) => state.init);
  const featureToggles = sessionInfo?.sessionInfo?.featureToggles;

  useEffect(() => {
    window.addEventListener('updateToggle', function handleConfigChange(e) {
      if (featureToggles) {
        const updatedFeatureToggles = {
          ...featureToggles,
          ...(e as CustomEvent).detail,
        };
        dispatch(updateFeatureToggles(updatedFeatureToggles));
      }
    });

    return () => {
      window.removeEventListener(
        'updateToggle',
        function handleConfigChange(e) {},
      );
    };
  }, [featureToggles]);

  return (
    <>
      <Script id={'dy_update_toggle'} type="text/javascript">
        {`
        window.triggerToggleUpdate = (data) => {
          window.dispatchEvent(new CustomEvent("updateToggle", { detail: data }));
        };
      `}
      </Script>
    </>
  );
};

export default FeatureToggles;
